import { useLayoutEffect, useState, useRef } from 'react'

import { useWindowWidth } from 'core/ui/hooks/useWindowWidth'

import { TooltipContainer, TooltipBubbleContainer } from './Tooltip.styles'

function Tooltip(props) {
  return <TooltipContainer {...props} />
}

function TooltipBubble(props) {
  const [rightOffset, setRightOffset] = useState(0)
  const [leftOffset, setLeftOffset] = useState(0)
  const windowWidth = useWindowWidth(0)
  const bubbleRef = useRef()

  useLayoutEffect(() => {
    if (bubbleRef.current) {
      const { right, left } = bubbleRef.current.getBoundingClientRect()
      if (right > windowWidth) {
        setRightOffset(right - windowWidth)
        setLeftOffset(0)
      } else if (left < 0) {
        setRightOffset(0)
        setLeftOffset(-left)
      } else {
        setRightOffset(0)
        setLeftOffset(0)
      }
    }
  }, [windowWidth])

  return (
    <TooltipBubbleContainer
      ref={bubbleRef}
      rightOffset={rightOffset}
      leftOffset={leftOffset}
      {...props}
    />
  )
}

Tooltip.Bubble = TooltipBubble

export { Tooltip }
